<script lang="ts">
  import { appStore } from "$app/store.svelte"

  export let step: number
  const meeting_type = appStore.meeting_type

  const steps = {
    quarterly: [
      "Recognitions",
      "Plan Review",
      "Quarter Review",
      "SWOT Review",
      "One Page Review"
    ],
    annual: [
      "Recognitions",
      "Plan Review",
      "Annual Review",
      "Quarter Review",
      "SWOT Review",
      "Finalize"
    ]
  }[meeting_type]

  const svg = `<svg class="w-5 h-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path></svg>`
</script>

<nav aria-label="Progress">
  <ol
    class="px-4 lg:px-6 bg-white border border-gray-300 rounded-md divide-y divide-gray-300 md:flex md:divide-y-0"
  >
    {#each steps as st, idx}
      {@const index = idx + 1}
      {@const cls =
        step === index
          ? "flex-shrink-0 w-8 h-8 flex items-center justify-center border bg-green-400 border-green-500 rounded-full  text-white font-bold text-lg"
          : "text-gray-500 group-hover:text-gray-900"}
      <li class="relative md:flex-1 md:flex">
        <a
          href="?step={index}"
          class="group flex items-center"
          class:font-medium={step === index}
        >
          <span class="px-4 py-4 flex items-center text-sm font-medium">
            <span
              class="flex-shrink-0 w-8 h-8 flex items-center justify-center border-2 rounded-full"
              class:border-gray-300={step <= index}
              class:bg-green-400={step > index}
              class:border-green-500={step > index}
            >
              {#if step > index}
                {@html svg}
              {:else}
                <span class={cls}>
                  {index}
                </span>
              {/if}
            </span>
            <span
              class="ml-4 text-sm font-medium text-gray-500 group-hover:text-gray-900 {step ===
              index
                ? 'font-bold text-gray-800'
                : ''}"
            >
              {st}
            </span>
          </span>
        </a>
        {#if step >= index}
          <div
            class="hidden md:block absolute top-0 right-0 h-full w-5"
            aria-hidden="true"
          >
            <svg
              class="h-full w-full text-gray-300"
              viewBox="0 0 22 80"
              fill="none"
              preserveAspectRatio="none"
            >
              <path
                d="M0 -2L20 40L0 82"
                vector-effect="non-scaling-stroke"
                stroke="currentcolor"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        {/if}
      </li>
    {/each}
  </ol>
</nav>
